<div class="cmp-container learnspace-theme" *ngIf="learnspace">
  <page-header [title]="learnspace.title" [backgroundUrl]="learnspace?.postermedia?.path"></page-header>

  <div class="page-container" >
    <div id="card-container" *loading="loadStatus">
        <mat-card *ngFor="let stat of statsCards" class="stat-card">
          <stat-card [icon]="stat.icon" [label]="stat.label" [sublabel]="stat.sublabel"></stat-card>
        </mat-card>
    </div>

    <div class="experience-container">
      <experience-card *ngFor="let xp of popularExperiences" [course_id]="xp.id" [date_from]="date_from" [date_to]="date_to"></experience-card>
    </div>
  </div>
</div>
